// extracted by mini-css-extract-plugin
export var answer = "FAQ-module--answer--wpQD6";
export var row = "FAQ-module--row--nZT55";
export var tableRow = "FAQ-module--tableRow--465wB";